module.exports = __webpack_public_path__ + "static/media/5310.186123b1.jpg";